import React, { useState, useEffect } from 'react';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';

const CardBenData = ({ checkedItems, setCheckedItems, handleChangeChecked }) => {

    useEffect(() => {
        setCheckedItems(prevState => {
            if (prevState.length === 0) {
                return [true];
            } else {
                return prevState;
            }
        });
    }, [setCheckedItems]);

    return (
        <div>
            <Card
                sx={{
                    maxWidth: 330,
                    minWidth: 200,
                    borderRadius: '8px',
                    marginBottom: '30px',
                    marginRight: '12px',
                    marginLeft: '12px',
                    paddingLeft: '5px',
                    paddingRight: '25px'
                }}
            >
                <CardContent sx={{ width: 320, height: 'max-content', color: '#ED1C24' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <Box>
                            <Typography gutterBottom variant="h8" component="div">
                                <FamilyRestroomIcon />
                            </Typography>
                        </Box>
                        <Box style={{ width: '80%' }}>
                            <Typography gutterBottom variant="h8" component="div" style={{ fontFamily: 'Roboto', marginTop:'12px',fontSize:'14px' }}>
                                <strong style={{ marginLeft: '8px' }}>Beneficiarios legales</strong>
                            </Typography>
                        </Box>
                        <Box style={{ marginLeft: '0px' }}>
                            <Checkbox
                                checked={checkedItems.legalBeneficiaries || false}
                                onChange={() => handleChangeChecked(0)}
                                inputProps={{ 'aria-label': 'controlled' }}
                                color="secondary"
                            />
                        </Box>
                    </Box>
                    <Typography
                        gutterBottom
                        variant="h8"
                        component="div"
                        sx={{ color: '#181a19', marginBottom: '10px' }}
                        style={{ fontFamily: 'Roboto' }}
                    >
                        <strong style={{ color: '#181a19', fontSize: '0.8rem' }}>Son las personas que heredan tal como establece la ley. Pueden ser:</strong>
                    </Typography>
                    <Box>
                        <ul>
                            <li>
                                <Typography sx={{ color: '#181a19', fontSize: '0.8rem' }}  style={{ fontFamily: 'Roboto' }}>
                                    Tus descendientes (Hijos/as, nietos/as)
                                </Typography>
                            </li>
                            <li>
                                <Typography sx={{ color: '#181a19', fontSize: '0.8rem' }}  style={{ fontFamily: 'Roboto' }}>
                                    Tus ascendientes (Papá, mamá, abuelo/a)
                                </Typography>
                            </li>
                            <li>
                                <Typography sx={{ color: '#181a19', fontSize: '0.8rem' }}  style={{ fontFamily: 'Roboto' }}>
                                    Tu cónyuge (Pareja)
                                </Typography>
                            </li>
                            <li>
                                <Typography sx={{ color: '#181a19', fontSize: '0.8rem' }}  style={{ fontFamily: 'Roboto' }}>
                                    Tus parientes colaterales hasta el cuarto grado inclusive (Hermanos/as, tíos/as, primos/as)
                                </Typography>
                            </li>
                            <li>
                                <Typography sx={{ color: '#181a19', fontSize: '0.8rem' }} style={{ fontFamily: 'Roboto' }}>
                                    Si no hay herederos, el estado.
                                </Typography>
                            </li>
                        </ul>
                    </Box>
                </CardContent>
            </Card>
            <Card
                sx={{
                    maxWidth: 330,
                    minWidth: 200,
                    borderRadius: '8px',
                    marginBottom: '30px',
                    marginRight: '12px',
                    marginLeft: '12px',
                    paddingLeft: '5px',
                    paddingRight: '25px'
                }}
            >
                <CardContent sx={{ width: 320, height: 'max-content', color: '#ED1C24' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <Box>
                            <Typography gutterBottom variant="h8" component="div">
                                <GroupAddIcon />
                            </Typography>
                        </Box>
                        <Box style={{ width: '80%' }}>
                            <Typography gutterBottom variant="h8" component="div" style={{ fontFamily: 'Roboto', marginTop:'12px',fontSize:'14px' }}>
                                <strong style={{ marginLeft: '8px' }}>Otros beneficiarios</strong>
                            </Typography>
                        </Box>
                        <Box style={{ marginLeft: '0px' }}>
                            <Checkbox
                                checked={checkedItems.otherBeneficiaries}
                                onChange={() => handleChangeChecked(1)}
                                inputProps={{ 'aria-label': 'controlled' }}
                                color="secondary"
                            />
                        </Box>
                    </Box>
                    <Typography
                        gutterBottom
                        variant="h8"
                        component="div"
                        sx={{ color: '#181a19', marginBottom: '10px' }}
                        style={{ fontFamily: 'Roboto' }}
                    >
                        <strong style={{ color: '#181a19', fontSize: '0.8rem' }}>Tú eliges a quién o quienes quieres asegurar.</strong>
                    </Typography>
                    <Box>
                        <ul>
                            <li>
                                <Typography sx={{ color: '#181a19', fontSize: '0.8rem' }} style={{ fontFamily: 'Roboto' }}>
                                    Incluye a cualquier persona, sea o no beneficiario legal de pertenencia.
                                </Typography>
                            </li>
                            <li>
                                <Typography sx={{ color: '#181a19', fontSize: '0.8rem' }} style={{ fontFamily: 'Roboto' }}>
                                    Puedes sumar beneficiarios legales y no legales, menores o mayores de edad.
                                </Typography>
                            </li>
                            <li>
                                <Typography sx={{ color: '#181a19', fontSize: '0.8rem' }} style={{ fontFamily: 'Roboto' }}>
                                    Beneficia a la cantidad de personas que desees.
                                </Typography>
                            </li>
                        </ul>
                    </Box>
                </CardContent>
            </Card>
        </div>
    );
};

export default CardBenData;
